import {createAction, createReducer} from 'redux-act';
import {AxiosPromise, AxiosResponse} from 'axios';
import {FULFILLED, PENDING} from 'redux-promise-middleware';

import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';
import {WizardTreeType} from '@optimaxdev/wizard-ms';
import {createSelector} from 'reselect';
import {ApplicationStoreType} from 'reducers';

type AvailablePackageCouponType = {discountAmount: number; coupon: string};

export const initialState = {
    status: '',
    packageCouponStatus: '',
    isSafety: false,
    availablePackageCoupon: {
        coupon: '',
        discountAmount: 0,
    },
};

export type PackagesDataFetchType = {
    productId: number;
    selectedUsageSku: string;
    selectedPackageSku?: string;
    selectedPackageTitle?: string;
};

export type PackagesCouponType = {
    content: string;
    coupon: string;
};

export const GET_WIZARD_MS = 'GET_WIZARD_MS';

export const setMultiLensCoupon = createAction<AvailablePackageCouponType>('SET_MULTILENS_COUPON');

/**
 * setWizardData used to imitate createAction flow for redux
 * to trigger all sagas and stores
 * @returns {ActionType} action
 * @param {status} status of request
 * @param {payload} payload of request
 */
export const setWizardData = (
    status: 'FULFILLED' | 'PENDING' | 'REJECTED',
    payload?: AxiosResponse<WizardTreeType>,
) => ({
    type: `${GET_WIZARD_MS}_${status}`,
    payload: payload || null,
});

export const getWizard = createAction(
    'GET_WIZARD_MS',
    (templateId: string | number, productId: number) =>
        instanceGusaBackend({
            method: 'GET',
            headers: {Authorization: ''},
            url: `${ENDPOINTS.API_URL_WIZARD}/${templateId}`,
            params: {
                productId,
            },
        }),
);

export const fetchPackagesCoupon = createAction<
    PackagesDataFetchType,
    AxiosPromise<PackagesCouponType>
>('FETCH_PACKAGES_REMINDERS', ({productId, selectedUsageSku, selectedPackageTitle}) => {
    return instanceGusaBackend({
        method: 'get',
        url: `${ENDPOINTS.PRODUCT_GET_BANNER_COUPON}?product=${productId}&package=${selectedPackageTitle}&lenstype=${selectedUsageSku}`,
    });
});

export const wizardData = createReducer(
    {
        [`${getWizard}_${PENDING}`]: state => ({
            ...state,
            status: '',
        }),
        [`${getWizard}_${FULFILLED}`]: (state, {data}) => ({
            ...state,
            status: 'fulfilled',
            isSafety: data.tree.isSafety,
        }),
        [`${fetchPackagesCoupon}_${FULFILLED}`]: (state, {data}) => ({
            ...state,
            packageCoupon: data.coupon,
        }),
        [`${setMultiLensCoupon}`]: (state, payload: AvailablePackageCouponType) => ({
            ...state,
            availablePackageCoupon: payload,
        }),
    },
    initialState,
);

/**
 * get wizard data
 * @param {ApplicationStoreType} store store
 * @returns {wizardData} wizardData reducer
 */
export const getWizardData = (store: ApplicationStoreType) => store.wizardMs.wizardData;

export const isPendingWizardData = createSelector(
    getWizardData,
    ({packageCouponStatus, status}): boolean =>
        packageCouponStatus === 'pending' || status === 'pending',
);
